import LaboratoryOptionGuardsMixin from '@/modules/laboratoryModule/mixins/LaboratoryOptionGuardsMixin'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import { uniqBy } from 'lodash'
import LaboratoryDynamicServices from '@/modules/laboratoryModule/services/laboratoryDynamicServices'

export default {
    name: 'InstrumentsModalMixin',
    mixins: [
        LaboratoryOptionGuardsMixin
    ],
    props: {
        title: { type: String, required: true },
        options: { type: Array },
        devices: { type: Array, required: true },
        fixedDevice: { type: Object }
    },
    data() {
        return {
            instrumentSelected: null,
            instrumentFixed: false,
            instrumentOverwritten: false
        }
    },
    computed: {
        modelValidated() {
            return !!this.instrumentSelected
        }
    },
    methods: {
        resetInstrumentsModalData() {
            this.instrumentSelected = null
            if (this.devices && this.fixedDevice) {
                this.instrumentSelected = this.devices.find(device => device.id === this.fixedDevice.id)
                if (this.instrumentSelected) {
                    this.instrumentFixed = true
                }
            }
        },
        async applyDevice(callback) {
            if (this.selectedOption) {
                if (this.options.length) {
                    let params = this.options.map(elem => {
                        if (this.selectedOption.type === ENTITIES_LABORATORY.PORTION) {
                            return this.getIdHierarchyFromPortion(elem)
                        } else if (this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                            return this.getIdHierarchyFromSubportion(elem)
                        }
                    })

                    if (this.selectedOption.typeAlt === ENTITIES_LABORATORY.PORTION) {
                        params = uniqBy(params, 'portionId')
                    }

                    if (params.length) {
                        const [err] = await this.toCall(
                            LaboratoryDynamicServices.applyDevice(
                                this.$store.getters.labId,
                                this.instrumentSelected.id,
                                [this.selectedOption.id],
                                this.instrumentOverwritten,
                                this.selectedOption.deviceType,
                                params
                            )
                        )
                        if (err) {
                            this.showErrorModalGlobal(this.$tc('laboratory.content.errorAction'))
                        } else {
                            this.showSuccessModalGlobal(this.$tc('laboratory.content.actionOk'))

                            this.$emit('device-applied', this.instrumentFixed ? this.instrumentSelected : null)
                            callback()
                        }
                    }
                }
            }
        }
    }
}
